export default __webpack_public_path__ + "static/alootiki-31d73f427b1e71e334ea34773517d874.png";